
import { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { updateProcodocsUploadedDocument } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"
import Button from "../../../../common/Button"
import { caseActions } from "../../../../../store/case"
import { validateBoxUploadFile } from "../../../../../lib/docs"


export default function FileUpdateButton({existingDocument, isGeneral, practiceId}) {
    const inputRef = useRef(null)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            const selectedFile = e.target.files[0]
            const sizeError = validateBoxUploadFile(selectedFile)
            if (sizeError) {
                dispatch(notificationActions.setError({
                    errorMessage: `"${selectedFile.name}" is too large. ${sizeError}`,
                }))
                e.target.value = ''
                return
            }

            let filesArray = [{
                id: Math.random(),
                file: selectedFile.name,
                file_to_upload: selectedFile,
            }]

            if(filesArray && filesArray.length) {

                let file = filesArray[0]
                let formData = new FormData();

                formData.append("file", file.file_to_upload);
                formData.append("for_case_attorney", 1);

                let reqBody = formData

                saveFileHandler(reqBody)
            }
        }

	}

    async function saveFileHandler(req) {
        setLoading(true)
        const upload = await updateProcodocsUploadedDocument(userToken, activeCase.case.id, existingDocument?.id ,req, dispatch)

        if (upload && upload.errorMessage) {
            dispatch(notificationActions.setError(upload))            
        } else {
            // /success 
            dispatch(caseActions.updateItemInProcoDocuments(upload))
        }

         setLoading(false)
    }

   

    const openUploadHandler = () => {
        inputRef.current.click()
    }
    return <>
        {(practiceId === 'all' || !isGeneral) && <>
            <input ref={inputRef} type="file" value="" onChange={onFileDrop} name="upload_number_1" id="upload_number_1" style={{display: 'none'}}/>
            <Button click={openUploadHandler} isLoading={loading} btnStyle={'btn_small_icon'} title={'Update file'}><i className="ti ti-upload" ></i></Button>
        </>}
    </>
}